/** DOM id of the hero's primary CTA wrapper. The header watches this element
 *  to decide when to reveal its own CTA (see useElementInView). */
export const HERO_PRIMARY_CTA_ID = 'hero-primary-cta';
